import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import api from '@/api/config'

const protectedCollections = new Set(['friends','partner','cashback','continuous_deposit','partner_all','cashback_all','continuous_deposit_all','krungsri','history','historyCredit','login','daily_deposit','daily_withdraw','spin','roulet','huays','codefree','setcredit','papaya','corepay','slip','autopeer','paybridge_deposits','redeem','redeemreward','waste','promotion','promotion_users','sharefriend','santaclaus'])
class MemberQuery {
  constructor (collection, filters = [], order = null, limit = null, id = null) { Object.assign(this, { collection, filters, order, limitValue: limit, id }) }
  where (field, op, value) { return new MemberQuery(this.collection, [...this.filters, { field, op, value }], this.order, this.limitValue, this.id) }
  orderBy (field, direction = 'asc') { return new MemberQuery(this.collection, this.filters, { field, direction }, this.limitValue, this.id) }
  limit (value) { return new MemberQuery(this.collection, this.filters, this.order, value, this.id) }
  doc (id) { return new MemberQuery(this.collection, this.filters, this.order, this.limitValue, id || firebase.firestore().collection(this.collection).doc().id) }
  get ref () { return this.id ? firebase.firestore().collection(this.collection).doc(this.id) : firebase.firestore().collection(this.collection) }
  get path () { return this.ref.path }
  async get () {
    const account = firebase.auth().currentUser
    const profile = JSON.parse(localStorage.getItem('userData') || 'null')
    if (!account || !profile || !profile.key) throw new Error('MEMBER_SESSION_REQUIRED')
    const result = await api.post('/api/member-read/' + profile.key, { collection: this.collection, filters: this.filters, order: this.order, limit: this.limitValue, id: this.id })
    const docs = result.data.documents.map(doc => ({ id: doc.id, exists: true, data: () => doc.data, ref: firebase.firestore().collection(this.collection).doc(doc.id) }))
    if (this.id) return docs[0] || { id: this.id, exists: false, data: () => undefined, ref: this.ref }
    return { docs, size: docs.length, empty: !docs.length, forEach: callback => docs.forEach(callback) }
  }
  onSnapshot (callback, errorCallback) {
    let cancelled = false
    let timer
    const poll = async () => {
      try { const result = await this.get(); if (!cancelled) callback(result) }
      catch (error) { if (!cancelled && errorCallback) errorCallback(error) }
      if (!cancelled) timer = window.setTimeout(poll, 12000)
    }
    poll()
    return () => { cancelled = true; window.clearTimeout(timer) }
  }
  set (...args) { return this.ref.set(...args) }
  update (...args) { return this.ref.update(...args) }
  delete (...args) { return this.ref.delete(...args) }
  add (...args) { return this.ref.add(...args) }
}
function firestore () {
  const actual = firebase.firestore()
  return { collection: name => protectedCollections.has(name.replace(/^\/+|\/+$/g, '')) ? new MemberQuery(name.replace(/^\/+|\/+$/g, '')) : actual.collection(name), batch: () => actual.batch(), runTransaction: (...args) => actual.runTransaction(...args) }
}
Object.assign(firestore, firebase.firestore)
const memberData = Object.create(firebase)
Object.defineProperty(memberData, 'firestore', { value: firestore })
export default memberData
